

export function getUrlParam(param) {
    let params = {}
    window.location.search.replace('?', '').split('&').forEach(paramStr => {
        params[paramStr.split('=')[0]] = paramStr.split('=')[1]
    })
    if (param in params) {
        return params[param]
    }
    return false;
}
